import { render } from "./Dashboard7.vue?vue&type=template&id=b5600a1a&scoped=true"
import script from "./Dashboard7.vue?vue&type=script&lang=js"
export * from "./Dashboard7.vue?vue&type=script&lang=js"

import "./Dashboard7.vue?vue&type=style&index=0&id=b5600a1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5600a1a"]])

export default __exports__